import { atom } from 'jotai';

/**
 * Stripe State
 */

interface CreditCardFormState {
  errorMsg?: string;
  formChanged: boolean;
  formComplete: boolean;
  formSubmitting: boolean;
  formSuccessful: boolean;
  tokenResponse?: stripe.TokenResponse;
}

interface StripeElementState {
  card?: stripe.elements.Element;
  paymentRequestButton?: stripe.elements.Element;
}

const InitialCreditCardFormState: CreditCardFormState = {
  errorMsg: undefined,
  formChanged: false,
  formComplete: false,
  formSubmitting: false,
  formSuccessful: false,
  tokenResponse: undefined,
};

const CreditCardFormAtom = atom<CreditCardFormState>(
  InitialCreditCardFormState,
);

const StripeElementAtom = atom<StripeElementState>({});

export const PaymentsState = {
  CreditCardFormAtom,
  InitialCreditCardFormState,
  StripeElementAtom,
};
